import { ValidatorFn, AbstractControl, ValidationErrors } from "@angular/forms";
export const SameNumberValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
   const taraNumber = control.get("tara");
   const netNumber = control.get("pesoNeto");
   const summed = +taraNumber.value + +netNumber.value;
   const grossNumber = control.get("pesoBruto");
   return summed && summed > grossNumber.value ? { greaterNet: true } : null;
};
